<!-- eslint-disable max-lines -->
<template>
    <paper class="dispatchOrder">
        <m-pane
            ref="tablePage"
            :initSearchInfo="initSearchInfo"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :optionNum="optionNum"
            :loading="loading"
            searchId="dispatchOrderQuery"
            pageID="dispatchOrder"
            :currentPage="currentPage"
            @row-db-click="rowDBclick"
            @dispatchDevice-btn="dispatchDeviceBtn"
            @taskDevice-btn="taskDeviceBtn"
            @check-btn="checkBtn"
            @adjust-btn="adjustBtn"
            @dispatch-btn="dispatchBtn"
            @onTheWay-btn="onTheWay"
            @parkAppoint-btn="parkAppointBtn"
            @changeWeight-btn="changeWeightBtn"
            @print-btn="printBtn"
            @printLog-btn="printLog"
            @contractLine-btn="contractLineBtn"
            @editor-btn="editorBtn"
            @trajectory-btn="trajectoryBtn"
            @costValidator-btn="costValidator"
            @inTransitEdit-btn="inTransitEdit"
            @costApprove-btn="costApprove"
            @abnormalReason-btn="abnormalReason"
            @viewTrack-btn="viewTrack"
            @cancelLoading-btn="cancelLoading"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT_OTP_DISPATCH"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp04040017'" class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    type="primary"
                    @click="handleStart"
                    v-has="'otp04040006'"
                    :disabled="startDisabled"
                    >发 车</el-button
                >
                <el-button
                    type="primary"
                    @click="handleRegistration"
                    v-has="''"
                    >整车异常发车原因</el-button
                >
            </div>
        </m-pane>

        <supplier-dialog
            v-if="controlVisiable"
            :controlVisiable.sync="controlVisiable"
            :taskDataList="taskDataList"
            @cancelControl="cancelControl"
            @addOkControl="addOkControl"
            :dataLists="dataObj"
        ></supplier-dialog>

        <carDialog
            @handleStartClose="handleStartClose"
            @start="start"
            :diaShaow.sync="diaShaow"
        ></carDialog>

        <initiation-slip-dialog
            v-if="cellShaowForm"
            :cellShaowForm.sync="cellShaowForm"
            @handleCellFormClose="handleCellFormClose"
            @cellStartForm="cellStartForm"
        ></initiation-slip-dialog>

        <print-dialog
            ref="print"
            v-if="dialogVisible"
            :dialogVisible.sync="dialogVisible"
            :componentsData="rowPrintData"
            :dictData="dictData"
            :professionalCompanyConfig="professionalCompanyConfig"
            @handleBillClose="handleBillClose"
        ></print-dialog>

        <!-- 新版打印窗口 -->
        <dispatch-new-print
            v-if="isShowNewPrintDialog"
            ref="dispatchNewPrint"
            :isShowNewPrintDialog.sync="isShowNewPrintDialog"
            :printConfig="printList"
            :dictData="dictData"
            :componentsData="componentsData"
            :professionalCompanyConfig="professionalCompanyConfig"
            @openOldPrintDialog="openOldPrintDialog"
        ></dispatch-new-print>

        <car-scheduling-dialog
            ref="AdmittRuleForm"
            :label-position="labelPosition"
            :RwCarVisiable.sync="RwCarVisiable"
            v-if="RwCarVisiable"
            :inOutType="dataObj.inOutType"
            :taskDataList="taskDataList"
            @handleRwCarClose="handleRwCarClose"
            @AdmittOk="AdmittOk"
            :dataLists="dataObj"
        >
        </car-scheduling-dialog>
        <!-- 发车单设备 -->
        <deviceDialog
            v-if="deviceVisible"
            :visible.sync="deviceVisible"
            :row="deviceRow"
            @refresh="clickSearch"
        >
        </deviceDialog>
        <!-- 任务设备 -->
        <task-device
            v-if="taskDeviceVisible"
            :taskDeviceVisible.sync="taskDeviceVisible"
            :componentsData="componentsData"
            @refresh="clickSearch"
        >
        </task-device>
        <detail-dialog
            ref="detailDialog"
            v-if="isDetailShow"
            :isDetailShow.sync="isDetailShow"
            class="adjust"
            :carrierName="carrierName"
            :label-position="labelPosition"
            @isDetailShowClose="isDetailShowClose"
            @detailShowOk="detailShowOk"
            :dispatchNo="dispatchNo"
        ></detail-dialog>
        <on-the-way-dialog
            v-if="onTheWayVisiable"
            :onTheWayVisiable.sync="onTheWayVisiable"
            :rowData="dataObj"
            @onTheWayClose="onTheWayClose"
            @saveOnTheWayDataOK="saveOnTheWayDataOK"
        ></on-the-way-dialog>
        <park-appoint
            v-if="parkApponitVisiable"
            :parkApponitVisiable.sync="parkApponitVisiable"
            :componentsData="dataObj"
            @closeRefresh="closeRefresh"
        ></park-appoint>
        <contractLineDialog
            v-if="contractVisible"
            :contractVisible.sync="contractVisible"
            :dataObj="dataObj"
            @costApprove="contractCostApprove"
        ></contractLineDialog>
        <register-reason-dialog
            v-if="registerVisible"
            :registerVisible.sync="registerVisible"
            :componentsData="componentsData"
            @close="saveRegisterData"
        ></register-reason-dialog>
        <inTransit-edit
            ref="inTransitEdit"
            v-if="inTransitEditShow"
            :componentsData="componentsData"
            :inTransitEdit.sync="inTransitEditShow"
            @components-close="handleCloseInTransitEdit($event)"
        ></inTransit-edit>
        <!-- 手工发车异常备注弹窗 -->
        <dispatch-abnormal-remark
            v-if="isShowRemarkDialog"
            ref="dispatchAbnormalRemark"
            :isShowRemarkDialog.sync="isShowRemarkDialog"
            :componentsData="componentsData"
            @handleBatchDepart="handleStart"
            @closeRemarkDialog="closeRemarkDialog"
        ></dispatch-abnormal-remark>

        <!-- 电子围栏校验提示和备注 -->
        <dispatch-handle-reason
            v-if="isShowHandleReasonDialog"
            ref="dispatchHandleReason"
            :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
            :componentsData="componentsData"
            :handleType="handleType"
            @handleSuccess="handleStart"
            @closeFenceDialog="closeFenceDialog"
        ></dispatch-handle-reason>

        <dispatch-print-log
            v-if="isShowPrintLogDialog"
            ref="dispatchPrintLog"
            :isShowPrintLogDialog.sync="isShowPrintLogDialog"
            :componentsData="componentsData"
        ></dispatch-print-log>

        <!-- 弹窗组件集合 componentsName区分对应的组件 componentsData传给组件的数据-->
        <component
            :is="componentsName"
            @components-close="componentsClose"
            :componentsData="componentsData"
        ></component>

        <el-dialog
            title="提示"
            :visible.sync="tipDialogVisible"
            width="30%"
            :before-close="handleCloseTip">
            <span>
                <i class="el-icon-warning-outline timeoutTip"></i>
                等待太久？您可以点击下方按钮，直接访问老版打印窗口。若继续等待，请不要退出界面，系统仍在匹配模板中，系统会根据匹配结果展示对应打印窗口。
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseTip">不打印了</el-button>
                <el-button type="primary" @click="handleOpenOldPrintf">跳转到老版打印界面</el-button>
            </span>
        </el-dialog>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './dispatch.json';
import paper from '@/components/core/paper/Paper';
import carSchedulingDialog from '../../../components/dialog/carSchedulingDialog';
import supplierDialog from '../../../components/dialog/supplierDialog';
import initiationSlipDialog from '../../../components/dialog/initiationSlipDialog';
import printDialog from './dispatchPrint/Index';
// 新打印弹窗
import DispatchNewPrint from './dispatchNewPrint/Index';
import DispatchPrintLog from '../dispatchMgmt/components/dispatchPrintLog/Index';
import carDialog from '../../../components/dialog/carDialog';
import detailDialog from '../../../components/dialog/detailDialog';
// 在途登记
import DispatchTransitRegistration from './dispatchTransitRegistration/Index';
import onTheWayDialog from './onTheWay';
import inTransitEdit from './dispatchInTransitEdit/Index.vue';
import contractLineDialog from './ContractLineDialog';
import { dictWithUrl } from '@/components/lots/api.js';
import formatTime from '@/utils/common.js';
import {
    getDispathOrderLists, getDispathOrderStart, getDispathOrderPreservation, judgeCost, startCostIflowApproval, getDispathOrderNoInitiationSlip, addressDetailHasChange, updateVolumnWeight, promptTrackType, getTaskList, cancelLoadStatus, isNeedExceptionRemarks,
    checkLclOperate
}
    from '../../../api/dispatchOrder';
import { queryTemplate, queryCompanyConfig } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import deviceDialog from './deviceDialog';
// TK单设备
import TaskDevice from './taskDevice/Index';
import bluemoonPrint from './bluemoonPrint';
import ParkAppoint from './parkAppointment/Index';
import RegisterReasonDialog from './registerReasonDialog.vue';
import DispatchAbnormalRemark from './dispatchAbnormalRemark.vue';
// 人工操作原因
import DispatchHandleReason from './dispatchHandleReason/Index';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState } from 'vuex';
import { isValidate, searchFieldSeperated, setAllPropertyValuesToNull } from './util.js';
import bigDataLog from '@/utils/bigDataLog';
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
    name: 'dispatchOrder',
    components: {
        mPane,
        paper,
        carSchedulingDialog,
        supplierDialog,
        initiationSlipDialog,
        reportExport,
        printDialog,
        DispatchNewPrint,
        DispatchPrintLog,
        carDialog,
        TaskDevice,
        deviceDialog,
        detailDialog,
        inTransitEdit,
        onTheWayDialog,
        contractLineDialog,
        ParkAppoint,
        RegisterReasonDialog,
        DispatchTransitRegistration,
        DispatchAbnormalRemark,
        DispatchHandleReason
    },
    data () {
        return {
            contractVisible: false,
            searchParams: {},
            initSearchInfo: {},
            deviceRow: {},
            BLUE_MOON_PSD_URL: '',
            deviceVisible: false,
            inTransitEditShow: false,
            dataObj: {},
            printList: [],
            radio: '',
            radios: '',
            tipDialogVisible: false,
            suspend: false,
            timeout: false,
            componentsName: '', // 组件名称
            componentsData: {}, // 行数据
            restaurants: [],
            timeout: null,
            besArriveDate: '',
            payMethod: '',
            procurements: [],
            characteristics: [],
            chargingOptions: [],
            carArrivals: [],
            taxRates: [],
            driverControlOptions: [],
            vehicleCardControlOptions: [],
            LicensePlateOptions: [],
            value: '',
            labelPosition: 'right',
            diaShaow: false,
            controlVisiable: false,
            cellShaowForm: false,
            dialogVisible: false,
            warehouseVisible: false,
            RwCarVisiable: false,
            isIndeterminate: true,
            config: config,
            loading: false,
            startDisabled: false,
            isShowElectron: false,
            isDetailShow: false,
            onTheWayVisiable: false,
            parkApponitVisiable: false,
            optionNum: 'SYS_WM_ASN_STATUS,SYS_WM_SO_STATUS',
            isFirstSearch: true,
            exportParams: {},
            totalData: [],
            selected: [],
            radioItems: [],
            hiddenEventType: [],
            searchDataLists: {},
            pageTotal: 0,
            currentPage: 1,
            page: {
                pageNo: 1,
                pageSize: 10
            },
            carrierName: '',
            rowPrintData: {},
            dispatchType: {
                '2': '仓配分离',
                '1': '排车计划',
                '0': '仓配一体'
            },
            registerVisible: false, // 异常原因登记弹窗
            componentsData: {},
            taskDataList: [],
            isShowRemarkDialog: false, // 是否显示异常原因备注弹窗
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'depart', // 操作类型：发车
            copySelectedData: [],
            isShowNewPrintDialog: false,
            isShowPrintLogDialog: false,
            taskDeviceVisible: false,
            professionalCompanyConfig: {},
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
            user: state => state.user,
            currentTenant: state => state.currentTenant
        })
    },
    activated () {
        if (this.$route.query.dispatchStatuss) {
            this.getRouterQuery();
            this.clickSearch();
        }
    },
    methods: {
        // 获取打印专司卡控配置
        queryCompanyConfig () {
            queryCompanyConfig().then(res => {
                if (res && +res.code === 0) {
                    this.professionalCompanyConfig = res.data || {};
                }
            }).catch(() => { });
        },
        getRouterQuery () {
            const dispatchStatuss = this.$route.query.dispatchStatuss;
            if (dispatchStatuss) {
                this.initSearchInfo = {
                    dispatchStatus: dispatchStatuss.split(',')
                };
                this.searchParams['dispatchStatuss'] = dispatchStatuss;
                this.$router.replace({ name: 'dispatchOrder', query: {} });
            }
        },
        // 调用点击搜索按钮
        clickSearch () {
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        // 发车单设备按钮
        dispatchDeviceBtn (data) {
            this.deviceRow = data;
            this.deviceVisible = true;
        },
        // 任务设备按钮
        taskDeviceBtn (data) {
            this.taskDeviceVisible = true;
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:在途登记
        */
        onTheWay (data) {
            this.componentsName = 'DispatchTransitRegistration';
            this.componentsData = data;
        },
        // 关闭组件
        componentsClose () {
            this.componentsName = '';
            this.loader();
        },
        // 编辑按钮
        checkBtn (data) {
            this.dataObj = data;
            this.dispatchNo = data.dispatchNo;
            this.version = data.version;
            this.RwCarVisiable = true;
            this.$nextTick(() => {
                this.$refs.AdmittRuleForm.AdmittRuleForm.routeNoList = data.lineCodes;
            });
        },
        // 取消发车单按钮
        dispatchBtn (data) {
            this.version = data.version;
            this.dispatchNo = data.dispatchNo;
            this.cellShaowForm = true;
        },
        contractLineBtn (data) {
            this.dataObj = data;
            this.contractVisible = true;
        },
        handleCloseTip () {
            this.suspend = true;
            this.loading = false;
            this.tipDialogVisible = false;
        },
        handleOpenOldPrintf () {
            this.suspend = true;
            this.loading = false;
            this.tipDialogVisible = false;
            this.componentsName = 'DispatchPrint';
        },
        // 打印按钮
        printBtn (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print');
            this.timeout = false;
            this.componentsData = data;
            // 试点范围内，展示新的打印弹窗
            if (data.newPrintFlag) {
                this.loading = true;
                const timer = setTimeout(() => {
                    this.tipDialogVisible = true;
                    this.timeout = true;
                }, 7000);
                queryTemplate({ dispatchNo: data.dispatchNo }).then(res => {
                    clearTimeout(timer);
                    if (res && +res.code === 0 && !this.suspend) {
                        if (!res.data) {
                            this.rowPrintData = data;
                            this.dialogVisible = true;
                        } else {
                            this.printList = res.data || [];
                            this.isShowNewPrintDialog = true;
                        }
                    } else {
                        this.rowPrintData = data;
                        this.dialogVisible = true; // 兜底接口报错，打开旧版打印
                    }
                })
                    .catch(() => { })
                    .finally(() => {
                        this.loading = false;
                        this.tipDialogVisible = false;
                    });
            } else {
                this.$nextTick(() => {
                    this.rowPrintData = data;
                    this.dialogVisible = true;
                });
            }
        },
        printLog (rowData) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print-log');
            this.componentsData = rowData;
            this.isShowPrintLogDialog = true;
        },
        /**
         * @description 回调函数,打开老版打印界面
         * @param {Object} data 行数据
        */
        openOldPrintDialog (componentsData) {
            this.$nextTick(() => {
                this.rowPrintData = componentsData;
                this.dialogVisible = true;
            });
        },
        tipMes (mes, duration = 4000) {
            this.$message({
                type: 'warning',
                duration: duration,
                dangerouslyUseHTMLString: true,
                message: mes,
                showClose: true
            });
        },
        // 成本校验
        costValidator (row) {
            if (row.procurementChannel !== '00') {
                return this.tipMes('只有采购渠道是自调车才能启动成本校验！');
            }
            if (row.standardCost && row.standardCost > 0) {
                return this.tipMes('目标成本已经存在，无需重复校验！');
            }
            const copyRow = Object.assign({}, row);
            copyRow.dispatchStatus = copyRow.originDispatchStatus;
            judgeCost(copyRow).then(res => {
                if (res) {
                    this.$message.success(res.msg);
                    this.loader();
                }
            });
        },
        contractCostApprove (row) {
            const copyRow = Object.assign({}, row);
            copyRow.dispatchStatus = copyRow.originDispatchStatus;
            startCostIflowApproval(copyRow).then(res => {
                if (res) {
                    window.open(res.data);
                    this.loader();
                }
            });
        },
        // 成本审批
        costApprove (row) {
            if (!row.standardCost) {
                return this.tipMes('自调目标成本为空不能启动成本审核流程，请先做[成本校验]!');
            }
            if (row.iflowStatus && row.iflowStatus !== '00' && row.iflowStatus !== '30') {
                return this.tipMes('流程状态已经存在且未完结不能重新启动流程！');
            }
            if (!row.costRate) {
                return this.tipMes('请先启动成本校验再启动MIP流程！');
            }
            const copyRow = Object.assign({}, row);
            copyRow.dispatchStatus = copyRow.originDispatchStatus;
            startCostIflowApproval(copyRow).then(res => {
                if (res) {
                    window.open(res.data);
                    this.loader();
                }
            });
        },
        // 编辑按钮 editor
        async editorBtn (data) {
             await getTaskList({ dispatchNo: data.dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    this.taskDataList = res.data.data;
                }
            });
            this.dataObj = data;
            this.dispatchNo = data.dispatchNo;
            this.version = data.version;
            this.controlVisiable = true;
        },
        // 轨迹图标按钮
        trajectoryBtn (data) {
            this.$router.push({
                name: 'trafficTrajectory',
                params: {
                    name: '/distribute/traffic-trajectory',
                    dispatchNo: data.dispatchNo
                }
            });
        },
        viewTrack (data) {
            this.$router.push({
                path: '/otp/distribute/dispatch-inRoad-monitor',
                query: {
                    dispatchNo: data.dispatchNo
                }
            });
        },
        // 在途编辑按钮
        inTransitEdit (data) {
            this.componentsData = data;
            this.inTransitEditShow = true;
        },
        handleCloseInTransitEdit (refresh) {
            this.inTransitEditShow = false;
            refresh && this.loader(this.searchDataLists);
        },
        _validateSearchParams () {
            const startTime = this.searchParams.startCreateTime || 0;
            const endTime = this.searchParams.endCreateTime || 0;
            var timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            const isExitDispatch = this.searchParams.dispatchNoList && this.searchParams.dispatchNoList.length;
            if (!isExitDispatch && !startTime) {
                return '发车单号 和 创建时间 不可同时为空';
            } else if (!isExitDispatch && startTime) {
                if (timeDifference > 32 * 24 * 60 * 60 * 1000) {
                    return '按时间查询时，查询/导出 时间跨度不可超过一个月！';
                }
            }
            if (this.searchParams.siteCodeList && this.searchParams.siteCodeList.length > 5) {
                return '服务平台最多支持查询5个'
            }
            if (this.searchParams.whCodeList && this.searchParams.whCodeList.length > 5) {
                return '仓库最多支持查询5个'
            }
            if (this.searchParams.whCodeList && this.searchParams.whCodeList.length > 0 && Math.floor(timeDifference / (24 * 3600 * 1000)) > 7) {
                return '暂可 查询/导出 7天内发车单';
            }
        },
        async initTableData (initData) {
            const arriveTypeSetMap = new Map();
            arriveTypeSetMap.set('', '').set('01', '手动到车').set('02', '直通宝到车').set('04', '直通宝到车').set('05', '直通宝到车').set('06', '围栏到车').set('07', 'CSP扫码到车');
            const flagCodeMap = new Map();
            flagCodeMap.set('Y', '是').set('N', '否');
            const onWayContactCategoryNameMap = new Map();
            onWayContactCategoryNameMap.set('1', '司机').set('2', '供应商');
            const dict = await dictWithUrl('SYS_MIP_IFLOW_STATUS,DISPATCH_STATUS,EXCEPTION_TYPE,OTP_TMS_PROCUREMENT_CHANNEL,DEVICETYPE,NO_CAR_CARRIER_TYPE,DISPATCH_TYPE,DISPATCH_WAY,ABNORMAL_DEPART_REASON,TMS_SHIPPING_TYPE,OTP_IN_OUT_TYPE');
            const dictData = dict.data;
            const tableData = initData.map((item, index) => {
                if (item.iflowLink) {
                    if (['10', '11'].includes(item.iflowStatus)) {
                        item.iflowLink = item.iflowLink.replace('view', 'edit');
                    }
                    item.linkName = '审批';
                }
                item.iflowStatusName = dictData.SYS_MIP_IFLOW_STATUS[item.iflowStatus] || item.iflowStatus;
                item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
                item['vehicleCard/equipmentName'] =
                    (item.vehicleCard ? item.vehicleCard : '') + '/' + (item.equipmentName ? item.equipmentName : '');
                item['driver/driverContactWay'] =
                    (item.driver ? item.driver : '') + '/' + (item.driverContactWay ? item.driverContactWay : '');
                item.dmsText = item.dmsFlag === 0 ? '否' : '是';
                item.mapDispatchName = item.mapDispatch? '是' : '否';
                item.arriveType = arriveTypeSetMap.get(item.arriveType);
                item.noCarPlatformFlagText = flagCodeMap.get(item.noCarPlatformFlag);
                item.onWayContactCategoryName = onWayContactCategoryNameMap.get(item.onWayContactCategory);
                item.originDispatchStatus = item.dispatchStatus;
                item.deviceTypeName = dictData.DEVICETYPE[item.deviceType] || item.deviceType;
                item.dispatchStatus = dictData.DISPATCH_STATUS[item.dispatchStatus] || item.dispatchStatus;
                item.exceptionTypeName = dictData.EXCEPTION_TYPE[item.exceptionType] || item.exceptionType;
                item.procurementChannelTetx = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel] || item.procurementChannel;
                item.noCarCarrierTypeName = dictData.NO_CAR_CARRIER_TYPE[item.noCarCarrierType] || item.noCarCarrierType;
                item.dispatchWayName = dictData.DISPATCH_WAY[item.dispatchWay] || item.dispatchWay;
                item.dispatchTypeName = this.dispatchType[item.dispatchType] || '';
                item.abnormalDepartReasonName = dictData.ABNORMAL_DEPART_REASON[item.abnormalDepartReason] || item.abnormalDepartReason;
                item.fullLoadRate = item.fullLoadRate && Math.round((item.fullLoadRate + Number.EPSILON) * 10000) / 100 + '%';
                item.ztbTransportFlag = String(item.ztbTransportFlag);
                item.shippingTypeName = dictData.TMS_SHIPPING_TYPE[item.shippingType];
                item.inOutTypeName = dictData.OTP_IN_OUT_TYPE[item.inOutType];
                return item;
            });
            return tableData;
        },
        initHiddenBtn (tableData) {
            tableData.forEach((subItem, subIndex) => {
                subItem.hiddenEvent = this.hiddenEventType = [];
                if (+subItem.originDispatchStatus === 0) {
                    subItem.hiddenEvent.push('print');
                }
                if ([100, 60, 50, 40].includes(+subItem.originDispatchStatus)) {
                    subItem.hiddenEvent.push('check', 'dispatch', 'editor');
                }
                if (!(subItem.procurementChannel === '190' && Number(subItem.originDispatchStatus) <= 30)) {
                    subItem.hiddenEvent.push('adjust');
                }
                if (![40, 50, 60].includes(+subItem.originDispatchStatus)) {
                    subItem.hiddenEvent.push('onTheWay');
                }
                if (subItem.originDispatchStatus > 30) {
                    subItem.hiddenEvent.push('costValidator', 'costApprove', 'contractLine', 'changeWeight');
                }
                if (subItem.procurementChannel !== '00') {
                    subItem.hiddenEvent.push('costValidator', 'costApprove');
                }
                if (subItem.iflowLink) {
                    subItem.hiddenEvent.push('costValidator');
                    if (['10', '11', '20', '30'].includes(subItem.iflowStatus)) {
                        subItem.hiddenEvent.push('costApprove', 'contractLine');
                    }
                }
                if (
                    !subItem.standardCost ||
                    (subItem.standardCost !== -1 && subItem.costRate < 5)
                ) {
                    subItem.hiddenEvent.push('costApprove');
                }
                if (['00', '120', '160', '170', '180'].includes(subItem.procurementChannel)) {
                    subItem.hiddenEvent.push('contractLine');
                }
                if ([100, 60, 50, 40, 10, 20, 30].includes(+subItem.originDispatchStatus)) {
                    subItem.hiddenEvent.push('dispatch');
                }
                if (subItem.inOutType === 'IN') {
                    subItem.hiddenEvent.push('parkAppoint');
                }
                if (subItem.cancelLoadFlag !== true) {
                    subItem.hiddenEvent.push('cancelLoading');
                }
                // 任务设备：发运类型为零担，展示按钮。否则隐藏
                // if (+subItem.shippingType !== 0) {
                //     subItem.hiddenEvent.push('taskDevice');
                // }
                const completeVehicle = +subItem.shippingType === 1; // 发运类型为整车
                const inTransit = +subItem.originDispatchStatus === 40; // 发车单状态为在途
                const baseOrder = +subItem.dispatchType === 6; // 发车单存在基地订单标识
                const procurementChannel = ['20', '40', '120', '171'].includes(subItem.procurementChannel); // 采购渠道为物流公司、车队供应商、快递公司、零担专线
                // 以上条件全部满足，展示 在途编辑 按钮，有一项不符合，则隐藏
                if (!completeVehicle || !inTransit || !baseOrder || !procurementChannel) {
                    subItem.hiddenEvent.push('inTransitEdit');
                }
            });
            return tableData;
        },
        loader (val) {
            const initialTime = this.$refs.tablePage.$refs.searchList.searchData.createTime;
            const dispatchNos = searchFieldSeperated(this.$refs.tablePage.$refs.searchList.searchData.dispatchNoList || '');
            this.searchDataLists.leaveDate = this.searchDataLists.leaveDate || [];
            this.searchParams = {
                ...this.searchParams,
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                dispatchNoList: dispatchNos,
                startCreateTime: initialTime ? formatTime.formatDateTime(initialTime[0]) : '',
                endCreateTime: initialTime ? formatTime.formatDateTime(initialTime[1]) : '',
                leaveBeginDate: this.searchDataLists.leaveDate[0] || '',
                leaveEndDate: this.searchDataLists.leaveDate[1] || '',
                startDispatchTime: this.searchDataLists.dispatchTime ? this.searchDataLists.dispatchTime[0] : '',
                endDispatchTime: this.searchDataLists.dispatchTime ? this.searchDataLists.dispatchTime[1] : '',
                taskNo: this.searchDataLists.taskNo,
                isPrintAssembly: this.searchDataLists.isPrintAssembly,
                siteNameList: this.searchDataLists.siteNameList,
                siteCodeList: this.searchDataLists.siteCodeList,
                whNameList: this.searchDataLists.whNameList,
                whCodeList: this.searchDataLists.whCodeList,
                procurementChannel: this.searchDataLists.procurementChannel,
                createUserNameDispatch: this.searchDataLists.createUserNameDispatch,
                customerOrderNoList: this.searchDataLists.customerOrderNoList,
                orderNo: this.searchDataLists.orderNo,
                carrierName: this.searchDataLists.carrierName,
                vehicleCard: this.searchDataLists.vehicleCard,
                isReject: this.searchDataLists.isReject,
                ...val
            };
            // this.searchParams['carrierVisibleFlag'] = 'Y';
            this.searchParams['carrierCode'] = this.supplier.supplierCode;
            if (this._validateSearchParams()) return this.$message.warning(this._validateSearchParams());
            this.isFirstSearch = false;
            delete this.searchParams.leaveDate;
            this.currentPage = this.page.pageNo;
            this.exportParams = {
                ...this.searchParams,
                dispatchStatuss: this.strToArr(this.searchParams.dispatchStatuss)
            };
            this.loading = true;
            getDispathOrderLists(this.searchParams).then(async res => {
                if (res && res.code === '0') {
                    const tableData = await this.initTableData(res.data.list || []);
                    this.totalData = this.initHiddenBtn(tableData);
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        strToArr (str) {
            if (str) return str.split(',');
            return [];
        },
        isPlatoonMsg(res) {
            if (res && res.data && typeof res.data === 'string' && res.data.includes('该正向发车单有退货入库单')) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    showClose: true,
                    message: `<div>
                                    <span style="white-space: pre-line;">发车单号：${res.data}</span>
                                </div>`,
                    type: 'success',
                    duration: 5000
                });
                return false;
            }
            return true;
        },
        AdmittOk (formName) {
            const version = this.version;
            const dispatchNo = this.dispatchNo;
            formName.data['dispatchNo'] = dispatchNo;
            formName.data['version'] = version;
            formName.data['operateEntrance']='LSP'
            if (formName.state === true) {
                getDispathOrderPreservation(formName.data, this.dispatchNo, this.version).then(res => {
                    if (res && res.code === '0') {
                        this.isPlatoonMsg(res) && this.$message.success('编辑成功');
                        this.RwCarVisiable = false;
                        if (formName.data.vehicleCard && formName.data.vehicleCard !== '*') {
                            this.getPromptTrackType(this.dispatchNo);
                        }
                        this.loader(this.searchDataLists);
                    } else {
                        this.RwCarVisiable = true;
                    }
                }).catch(() => {
                    this.RwCarVisiable = true;
                });
            } else {
                return false;
            }
        },
        getPromptTrackType (dispatchNo) {
            promptTrackType(dispatchNo).then(res => {
                if (res && +res.code === 0 && res.data && +res.data.shippingType === 1) {
                    if (+res.data.isZjxl === 0) {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                    } else if (+res.data.isZjxl === 1) {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                    } else {
                        this.$message.warning('未知车辆北斗入网状态，请要求司机全程打开直通宝');
                    }
                }
            });
        },
        handleRwCarClose () { this.RwCarVisiable = false; },
        handleBillClose (data) {
            this.dialogVisible = false;
            if (data === 'closePrintDialog') {
                this.$nextTick(() => {
                    this.isShowNewPrintDialog = false;
                });
            }
        },
        handleCellFormClose () { this.cellShaowForm = false; },
        cellStartForm () {
            const params = {
                dispatchNo: this.dispatchNo
                // version: this.version
            };
            getDispathOrderNoInitiationSlip(params).then(res => {
                if (res.code === '0') {
                    this.$message.success('取消发车单成功');
                    this.loader(this.searchDataLists);
                }
            });
            this.cellShaowForm = false;
        },
        addOkControl (formName) {
            const version = this.version;
            const dispatchNo = this.dispatchNo;
            formName.data['dispatchNo'] = dispatchNo;
            formName.data['version'] = version;
            formName.data['operateEntrance']='LSP'
            if (formName.state === true) {
                getDispathOrderPreservation(formName.data, this.dispatchNo, this.version).then(res => {
                    if (res && res.code === '0') {
                        if (res.msg === 'Success') {
                            this.$message.success('保存成功');
                        } else if (res.msg.includes('风控代码')) {
                            this.$confirm(`<div style="white-space: pre-line;overflow-y: auto;">${res.msg}</div>`, '提示', {
                                confirmButtonText: '确定',
                                dangerouslyUseHTMLString: true,
                                type: 'warning',
                                showClose: false,
                                showCancelButton: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {});
                        } else {
                            this.$message({
                                showClose: true,
                                type: 'success',
                                duration: 5000,
                                message: `${res.msg}`
                            });
                        }
                        this.cancelControl();
                        if (formName.data.vehicleCard && formName.data.vehicleCard !== '*') {
                            this.getPromptTrackType(this.dispatchNo);
                        }
                        this.loader(this.searchDataLists);
                    }
                });
            } else {
                return false;
            }
        },
        cancelControl () { this.controlVisiable = false; },
        selectChange (data) {
            data.forEach(item => {
                this.dispatchNo = item.dispatchNo;
            });
            this.selected = [].concat(data);
        },
        // 关闭备注弹窗
        closeRemarkDialog () {
            this.isShowRemarkDialog = false;
            // this.loader(this.searchDataLists);
        },

        // 关闭围栏备注弹窗
        closeFenceDialog () {
            this.isShowHandleReasonDialog = false;
            this.copySelectedData = _.cloneDeep(this.selected);
            this.loader(this.searchDataLists);
        },

        // 套牌车白名单校验 是否需要备注发车原因
        isHandleRemark (data) {
            const dispatchNoList = data.map(v => v.dispatchNo);
            return isNeedExceptionRemarks(dispatchNoList).then(res => {
                if (res && +res.code === 0) {
                    return res.data;
                }
            }).catch(() => {
                return false;
            });
        },
        // 电子围栏校验，接口返回true则需要备注人工操作原因
        validateFence (data) {
            return checkLclOperate({ dispatchNo: data.dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    return res.data;
                }
            }).catch(() => {
                return false;
            });
        },
        /**
         * @description 发车
         * @param {Boolean} isRemarked （套牌车白名单校验）是否已备注发车原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async handleStart ({ isRemarked = false, isFenceRemarked = false }) {
            if (this.selected.length === 0) {
                this.$message.warning('至少选择一条数据');
                return;
            } else if (this.selected.length > 20) {
                this.$message.warning('最多只能选择20条数据');
                return;
            }
            const existExpressNo = this.selected.filter(i => i.expressNo);
            if (existExpressNo.length > 0) {
                return this.$message.warning(`${existExpressNo.map(v => v.dispatchNo).join(',')}存在快递单号，不能进行批量发车`);
            }
            // 需要备注发车原因且未备注时
            if (!isRemarked) {
                // 校验是否需要备注发车原因
                const isValidate = await this.isHandleRemark(this.selected);
                if (isValidate) {
                    this.isShowRemarkDialog = true;
                    this.componentsData = this.selected;
                    return;
                };
            }
            // 电子围栏校验 提示和备注原因(单条操作，不进行批量处理)
            if (!isFenceRemarked && this.selected.length === 1) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence(this.selected[0]);
                if (isNeedTooltip) {
                    this.$nextTick(() => {
                        this.isShowHandleReasonDialog = true;
                        this.componentsData = this.selected[0];
                    });
                    return;
                }
            }
            // 继续发车操作
            const flag = this.selected.find(item => {
                const isZiDiaoChe = item.procurementChannel === '00';
                if (item.iflowLink && item.iflowStatus !== '30') {
                    const prefixMsg = isZiDiaoChe ? '采购渠道为自调车' : '为合同外自调';
                    this.tipMes(`<div>发车单号<span style='color: #F56C6C;'>${item.dispatchNo}</span>${prefixMsg},成本审核流程未通过不能发车！</div>`, 5000);
                    return true;
                }
                if (isZiDiaoChe && !item.iflowLink) {
                    if (!item.standardCost) {
                        this.tipMes(`<div>发车单号<span style='color: #F56C6C;'>${item.dispatchNo}</span>采购渠道为自调车，[标准成本]为空,请先操作[成本校验]！</div>`, 5000);
                        return true;
                    } else if (item.standardCost === -1 || parseFloat(item.costRate) >= 5) {
                        this.tipMes(`<div>发车单号<span style='color: #F56C6C;'>${item.dispatchNo}</span>需要启动成本审核流程,请先操作[成本审批]！</div>`, 5000);
                        return true;
                    }
                }
            });

            if (flag) return false;
            for (let index = 0; index < this.selected.length; index++) {
                if (this.selected[index].scanNum > 0 && this.selected[index].dispatchStatus !== '待发车') {
                    this.diaShaow = false;
                    return this.$message.warning('请先完成装货确认再发车');
                } else if (this.selected[index].dispatchStatus !== '待发车') {
                    this.diaShaow = false;
                    return this.$message.warning('已装车状态下才能发车');
                } else {
                    if (this.selected[index].dmsFlag === '1' && this.selected[index].totalMileage <= 0) {
                        return this.$message.warning('未计算里程，不允许发车');
                    } else {
                        const dispatchNos = [];
                        this.selected.forEach(item => {
                            dispatchNos.push(item.dispatchNo);
                        });
                        addressDetailHasChange(dispatchNos).then(res => {
                            if (res && res.code === '0') {
                                if (res.data) {
                                    this.$message.warning(res.msg);
                                }
                            }
                        });
                        this.diaShaow = true;
                    }
                }
            }
        },
        // isStart 是否确认发车
        start (isStart = false) {
            var arr = [];
            // 防止因刷新页面导致选中数据丢失
            const flag = isStart && this.selected.length === 0;
            const selectListData = flag ? this.copySelectedData : this.selected;
            selectListData.forEach(item => {
                arr.push({ dispatchNo: item.dispatchNo, version: item.version, inOutType: item.inOutType, queueCode: item.queueCode });
            });
            getDispathOrderStart(arr).then(res => {
                let message = '';
                let type = '';
                res.data.forEach(item => {
                    if (item.success === 1) {
                        type = `warning`;
                        message += `<div style='line-height: 30px;'>
                                <span style='color: #e6a23c;'>发车单号</span>
                                <span style='color: #e6a23c;'>${item.dispatchNo}</span>
                                <span style='color: #e6a23c;'>${item.message}</span></div>`;
                    } else if (item.success === 0) {
                        type = `success`;
                        message += `<div style='line-height: 30px;'>
                                <span style='color: #67c23a;'>发车单号</span>
                                <span style='color: #67c23a;'>${item.dispatchNo}</span>
                                <span style='color: #67c23a;'>${item.message}</span></div>`;
                    } else {
                        type = `warning`;
                        message += `<div style='line-height: 30px;'>
                                <span style='color: #909399;'>发车单号</span>
                                <span style='color: #F56C6C;'>${item.dispatchNo}</span>
                                <span style='color: #409EFF;'>${item.message}</span></div>`;
                    }
                });
                const duration = 5000 + res.data.length * 1500;
                this.$message({
                    type: type,
                    duration,
                    dangerouslyUseHTMLString: true,
                    message,
                    showClose: true
                });
                this.startDisabled = false;
                this.loader(this.searchDataLists);
            }).catch(() => {
                this.startDisabled = false;
            });
            this.diaShaow = false;
            this.startDisabled = true;
        },
        handleStartClose () { this.diaShaow = false; },
        rowDBclick (row) {
            this.$router.push({
                query: { dispatchNo: row.dispatchNo },
                path: `/otp/dispatch-order/dispatch-order-detail`
            });
        },
        searchChange (data) {
            data.dispatchStatuss = data.dispatchStatus.join();
            delete data.dispatchStatus;
            this.page.pageNo = 1;
            this.searchDataLists = data;
            const dispatchList = searchFieldSeperated(data.dispatchNoList || '');
            if (dispatchList.length > 100) {
                return this.$message.warning('一次最多支持查询100个发车单号');
            }
            this.searchDataLists.dispatchNoList = dispatchList;
            const customerOrderNoList = searchFieldSeperated(data.customerOrderNoList || '');
            if (customerOrderNoList.length > 100) {
                return this.$message.warning('一次最多查询100个订单号');
            }
            this.searchDataLists.customerOrderNoList = customerOrderNoList;

            if (this.searchDataLists.createTime !== null && this.searchDataLists.createTime !== '') {
                this.searchDataLists.startCreateTime = formatTime.formatDateTime(this.searchDataLists.createTime[0]);
                this.searchDataLists.endCreateTime = formatTime.formatDateTime(this.searchDataLists.createTime[1]);
                delete this.searchDataLists.createTime;
            } else {
                this.searchDataLists.startCreateTime = '';
                this.searchDataLists.endCreateTime = '';
            }
            if (this.searchDataLists.siteName) {
                this.searchDataLists.siteNameList = this.searchDataLists.siteName.length ? this.searchDataLists.siteName.split(',') : [];
                this.searchDataLists.siteCodeList = this.searchDataLists.siteCode.length ? this.searchDataLists.siteCode.split(',') : [];
            }
            if (this.searchDataLists.whCode) {
                this.searchDataLists.whNameList = this.searchDataLists.whName.length ? this.searchDataLists.whName.split(',') : [];
                this.searchDataLists.whCodeList = this.searchDataLists.whCode.length ? this.searchDataLists.whCode.split(',') : [];
            }
            delete this.searchDataLists.whName;
            delete this.searchDataLists.whCode;
            delete this.searchDataLists.siteName;
            delete this.searchDataLists.siteCode;
            if (this.searchDataLists.dispatchTime) {
                if (this.searchDataLists.dispatchTime !== null && this.searchDataLists.dispatchTime !== '') {
                    this.searchDataLists.startDispatchTime = this.searchDataLists.dispatchTime[0];
                    this.searchDataLists.endDispatchTime = this.searchDataLists.dispatchTime[1];
                } else {
                    this.searchDataLists.startDispatchTime = '';
                    this.searchDataLists.endDispatchTime = '';
                }
            } else {
                return this.loader(this.searchDataLists);
            }
            this.taskNo = data.taskNo;
            this.isPrintAssembly = data.isPrintAssembly;
            this.siteName = data.siteName;
            this.siteCode = data.siteCode;
            this.whName = data.whName;
            this.whCode = data.whCode;
            this.procurementChannel = data.procurementChannel;
            this.createUserNameDispatch = data.createUserNameDispatch;
            // this.custOrderNo = data.custOrderNo;
            this.orderNo = data.orderNo;
            this.carrierName = data.carrierName;
            this.vehicleCard = data.vehicleCard;
            delete this.searchDataLists.dispatchTime;
            this.loader(this.searchDataLists);
        },
        sizeChange (data) {
            this.currentPage = 1;
            this.page.pageSize = data;
            this.page.pageNo = 1;
            this.loader(this.searchDataLists);
        },
        pageChange (data) {
            this.page.pageNo = data;
            this.loader(this.searchDataLists);
        },
        adjustBtn (data) {
            this.dispatchNo = data.dispatchNo;
            this.carrierName = data.carrierName;
            this.isDetailShow = true;
        },
        isDetailShowClose () { this.isDetailShow = false; },
        detailShowOk (code) {
            if (code.code === '0') {
                this.isDetailShow = false;
                this.$nextTick(() => {
                    this.loader(this.searchDataLists);
                });
            }
        },
        onTheWayBtn (data) {
            this.dataObj = data;
            this.onTheWayVisiable = true;
        },
        onTheWayClose () {
            this.onTheWayVisiable = false;
        },
        parkAppointBtn (data) { // 园区预约
            this.dataObj = data;
            this.parkApponitVisiable = true;
        },
        changeWeightBtn (data) { // 更新重量
            const params = [data.dispatchNo];
            updateVolumnWeight(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('更新重量成功！');
                    this.loader(this.searchDataLists);
                }
            });
        },
        closeRefresh (visiableType) {
            this[visiableType] = false;
            this.loader(this.searchDataLists);
        },
        saveOnTheWayDataOK () {
            this.onTheWayVisiable = false;
            this.loader(this.searchDataLists);
        },
        /**
         * @description 整车异常发车原因登记
         */
        abnormalReason (data) {
            // 校验是否可登记
            const isOk = isValidate(data);
            if (!isOk) return;
            this.registerVisible = true;
            this.componentsData = data;
        },
        /**
         * @description 整车异常发车原因 批量登记
         */
        handleRegistration () {
            // 校验是否可登记
            const isOk = isValidate(this.selected);
            if (!isOk) return;
            this.registerVisible = true;
            this.componentsData = this.selected;
        },
        /**
         * @description 取消装货
         */
        cancelLoading (data) {
            cancelLoadStatus(data.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    this.loader(this.searchDataLists);
                }
            });
        },
        saveRegisterData () {
            this.registerVisible = false;
            this.loader(this.searchDataLists);
        },
        exportFile (submit) {
            const isFirstSearch = this.isFirstSearch;
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this._validateSearchParams()) return isFirstSearch ? '' : this.$message.warning(this._validateSearchParams());
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        // 获取基础数据
        async getBaseData () {
            const res = await dictWithUrl('SYS_MIP_IFLOW_STATUS,BLUE_MOON_PSD_URL,TRANSPORT_STATUS,DELIVERED_VERIFY_FLAG,SYS_OTP_TMS_NEWPRINT,ABNORMAL_DEPART_REASON,PRINT_TEMPLATE_STYLE_ATTRIBUTE,NEW_PRINTF_TIP_TEXT,NEW_PRINTF_TIP_URL');
            this.dictData = res.data;
            this.BLUE_MOON_PSD_URL = Object.entries(res.data.BLUE_MOON_PSD_URL)[0][0];
        },
        initialSearchFromIndex () {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            const beginDate = dayjs().subtract(30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
            const endDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.createTime = [beginDate, endDate];
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.dispatchStatus = this.$route.query.dispatchStatus ? this.$route.query.dispatchStatus.split(',') : [];
            this.searchParams['dispatchStatuss'] = this.$route.query.dispatchStatus || [];
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        }
    },
    mounted () {
        this.getRouterQuery();
        this.getBaseData();
        this.queryCompanyConfig();
    },
    beforeRouteEnter (to, from, next) {
        if (from.path === '/order-manage/task-detail') {
            next(vm => {
                if (vm.$route.params.dispatchNo) {
                    vm.$refs.tablePage.$refs.searchList.searchData.dispatchNoList = vm.$route.params.dispatchNo;
                    vm.$refs.tablePage.$refs.searchList.searchData.createTime = '';
                    vm.loader();
                }
            });
        } else if (from.path === '/dispatch-center') {
            next(vm => {
                if (vm.$route.params.dispatchNo) {
                    vm.dispatchNo = vm.$refs.tablePage.$refs.searchList.searchData.dispatchNoList = vm.$route.params.dispatchNo;
                    vm.carrierName = vm.$route.params.carrierName;
                    vm.loader();
                    vm.isDetailShow = true;
                }
            });
        } else if (from.path === '/index') {
            next(vm => {
                if (vm.$route.query && Object.keys(vm.$route.query).length) {
                    vm.initialSearchFromIndex();
                }
            });
        } else {
            next();
        }
    }
};
</script>

<style lang="less">
@import './dispatchOrder.less';
</style>
